import { render } from "./d-prediction-sumary-view.vue?vue&type=template&id=28e19a84&scoped=true&ts=true"
import script from "./d-prediction-sumary-view.vue?vue&type=script&lang=ts"
export * from "./d-prediction-sumary-view.vue?vue&type=script&lang=ts"

import "./d-prediction-sumary-view.vue?vue&type=style&index=0&id=28e19a84&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e19a84"]])

export default __exports__